import _                     from 'underscore';
import { reactLocalStorage } from 'reactjs-localstorage';
import { EnvironmentObject } from '../environments/types/base';

//@ts-ignore
let environment: EnvironmentObject = __ENV__;

interface UseLastRedirectHook {
	getLastRedirectURL: () => null | string,
	setLastRedirectURL: ( urlValue: string ) => string,
	clearLastRedirectURL: () => void,
}

const useLastRedirectURL = (): UseLastRedirectHook => {
	
	// Retrieves storage name from environment
	const getPrefsStorageKeyName = (): string => {
		return environment.session.cookies.lastRedirectUrl.namedKey
	}
	
	// Retrieves timestamp moment value
	const getLastRedirectURL: UseLastRedirectHook['getLastRedirectURL'] = () => {
		
		return reactLocalStorage.get( getPrefsStorageKeyName(), null );
	}
	
	// Sets timestamp moment value
	const setLastRedirectURL: UseLastRedirectHook['setLastRedirectURL'] = ( urlValue: string ) => {
		
		if( !_.isEmpty( urlValue ) ){
			
			return reactLocalStorage.set( getPrefsStorageKeyName(), urlValue );
		}
		
		return getLastRedirectURL();
	}
	
	// Sets timestamp to nothing
	const clearLastRedirectURL: UseLastRedirectHook['clearLastRedirectURL'] = () => {
		
		return reactLocalStorage.remove( getPrefsStorageKeyName() );
	}
	
	return {
		getLastRedirectURL,
		setLastRedirectURL,
		clearLastRedirectURL
	};
}

export { useLastRedirectURL }
